<template>
    <div class="modal fade" :class="{ in: isShowModal, active: isShow, }"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog">
            <div class="modal-content" style="border-radius: 10px">
                <!-- small box start -->
                <div class="small-box" v-if="showSmall">
                  <img @click="onModalClose" class="small-box-close" :src="currImgUrl+'close.png'" alt="" />
                  <div class="small-box-title">
                    不知道怎么选房？让我来帮你吧！
                  </div>
                  <div class="small-box-content">
                    <div class="dis-flex">
                      <img class="small-box-content-img" :src="currImgUrl+'peopleIcon.png'" alt="" />
                      <div>请输入出行人数</div>
                    </div>

                    <div class="small-box-content-box">

                      <div class="small-box-content-item">
                        <div>18周岁及以上乘客</div>
                        <div class="small-box-content-item-right">
                          <div class="small-item-count-box">
                            <img v-if="adultCount == 0" class="width-height-44" :src="currImgUrl + 'minus.png'" />
                            <img v-else class="width-height-44" :src="currImgUrl + 'minGray.png'" @click="changeAdlCount('mine')"/>
                            <div>{{adultCount}}</div>
                            <img v-if="adultCount == adultCountAll" @click="showCountLimit" class="width-height-44" :src="currImgUrl + 'plusGray.png'" />
                            <img v-else class="width-height-44" :src="currImgUrl + 'plus.png'" @click="changeAdlCount('plus')"/>
                          </div>
                          <div>人</div>
                        </div>
                      </div>

                      <div class="small-box-content-line"></div>

                      <div class="small-box-content-item">
                        <div>18周岁以下乘客</div>
                        <div class="small-box-content-item-right">
                          <div class="small-item-count-box">
                            <img v-if="childCount == 0" class="width-height-44" :src="currImgUrl + 'minus.png'" />
                            <img v-else class="width-height-44" :src="currImgUrl + 'minGray.png'" @click="changeCheCount('mine')"/>
                            <div>{{childCount}}</div>
                            <img v-if="childCount == childCountAll" @click="showCountLimit" class="width-height-44" :src="currImgUrl + 'plusGray.png'" />
                            <img v-else class="width-height-44" :src="currImgUrl + 'plus.png'" @click="changeCheCount('plus')"/>
                          </div>
                          <div>人</div>
                        </div>
                      </div>

                      <!-- 提示 -->
                      <div class="toest-box" v-if="isShowToast">
                        {{toastText}}
                      </div>

                    </div>

                      <div class="btn-box" @click="subCountPeple">
                        看看推荐
                      </div>

                  </div>
                  
                </div>
                <!-- small box end -->
                <!-- big box start -->
                 <div class="big-box" v-else>
                  <img @click="onModalClose" class="small-box-close" :src="currImgUrl + 'close.png'" alt="" />
                  <div class="big-box-title">
                    <strong>{{adultCount}}大{{childCount}}小</strong> 推荐您入住
                  </div>

                  <div class="small-box-content"> 
                    
                    <div class="big-item">
                        <div class="big-item-img">
                          <img :src="currImgUrl+'text1.png'" class="big-item-img-i"/>
                        </div>
                        <div class="big-item-text"
                          v-if="cheepData && cheepData.stateroomRecommendationRoomApiViews && cheepData.stateroomRecommendationRoomApiViews.length">
                          推荐您入住 <span class="color-blue big-margin-left-6"
                            v-if="cheepData.stateroomRecommendationRoomApiViews[0] && cheepData.stateroomRecommendationRoomApiViews[0].isConnectingRoom == false">{{ cheepData.stateroomRecommendationRoomApiViews[0].roomCount }}间</span>
                          <span
                            class="color-oringe big-margin-left-6" v-if="cheepData.stateroomRecommendationRoomApiViews[0]">{{ cheepData.stateroomRecommendationRoomApiViews[0].recommendationRoomMessage }}
                          </span> <span class="big-margin-left-6"
                            v-if="cheepData.stateroomRecommendationRoomApiViews.length > 1"> + </span>
                          <span class="color-blue big-margin-left-6"
                            v-if="cheepData.stateroomRecommendationRoomApiViews[1]&&cheepData.stateroomRecommendationRoomApiViews[1].isConnectingRoom == false">{{ cheepData.stateroomRecommendationRoomApiViews[1].roomCount }}间</span>
                          <span
                            class="color-oringe big-margin-left-6" v-if="cheepData.stateroomRecommendationRoomApiViews[1]">{{ cheepData.stateroomRecommendationRoomApiViews[1].recommendationRoomMessage }}
                          </span>
                        </div>
                      </div>

                      <div class="big-item" >
                        <div class="big-item-img">
                          <img :src="currImgUrl+'text2.png'" class="big-item-img-i"/>
                        </div>
                        <div class="big-item-text"
                          v-if="goodData && goodData.stateroomRecommendationRoomApiViews && goodData.stateroomRecommendationRoomApiViews.length">
                          推荐您入住 <span class="color-blue big-margin-left-6"
                            v-if="goodData.stateroomRecommendationRoomApiViews[0] && goodData.stateroomRecommendationRoomApiViews[0].isConnectingRoom == false">{{ goodData.stateroomRecommendationRoomApiViews[0].roomCount }}间</span>
                          <span
                            class="color-oringe big-margin-left-6" v-if="goodData.stateroomRecommendationRoomApiViews[0]">{{ goodData.stateroomRecommendationRoomApiViews[0].recommendationRoomMessage }}
                          </span> <span class="big-margin-left-6"
                            v-if="goodData.stateroomRecommendationRoomApiViews.length > 1"> + </span>
                          <span class="color-blue big-margin-left-6"
                            v-if="goodData.stateroomRecommendationRoomApiViews[1]&&goodData.stateroomRecommendationRoomApiViews[1].isConnectingRoom == false">{{ goodData.stateroomRecommendationRoomApiViews[1].roomCount }}间</span>
                          <span
                            class="color-oringe big-margin-left-6" v-if="goodData.stateroomRecommendationRoomApiViews[1]">{{ goodData.stateroomRecommendationRoomApiViews[1].recommendationRoomMessage }}
                          </span>
                        </div>
                      </div>

                      <div class="big-item">
                        <div class="big-item-img">
                          <img :src="currImgUrl+'text3.png'" class="big-item-img-i"/>
                        </div>
                        <div class="big-item-text">
                          推荐您入住<span class="color-oringe">套房</span>，尊享至多25项套房礼遇，包含管家服务、专属餐厅、优先登离船等。
                        </div>
                        <div class="color-blue-text" @click="onShowStateroomSuitePopup">
                          （ <span class="color-under-text">具体权益请参考套房礼遇</span> ）
                        </div>
                      </div>

                      <!-- 按钮区域 -->
                      <div>
                        <!-- 占位置 -->
                        <div class="gray-text">*推荐房型仅作参考，可能存在售罄或更优方案  </div>
                        <div class="botton-box" @click="backFist">
                          重新查询
                        </div>
                      </div>

                  </div>
                  
                 </div>
                <!-- big box end -->
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
export default {
    name: "helperRomePopover",
    props: {
        isShow: {
            type: Boolean
        },
        shipCodeHelper: {
          type: String,
          default: ''
        },
        showStateroomSuitePopup: {
          type: Function,
        },
        
    },
    data () {
        return {
            isShowModal: false,
            imgUrl: process.env.VUE_APP_IMG_URL,
            adultCount:0,
            childCount:0,

            adultCountAll:0,
            childCountAll:0,

            shipSuiteImagePC:'',
            cheepData:{},
            goodData:{},

            isShowToast:false,
            showSmall:true,

            list1:[{roomCount:0}],
            list2:[{roomCount:0}],

            currImgUrl: process.env.VUE_APP_IMG_URL + '/wechatMiniProgram/routesDetail/housingSelection/',

            toastText:'您房间中的乘客年龄可能不符合线上预订要求，具体请咨询客服'
        }
    },
    methods: {
        onShowStateroomSuitePopup() {
          this.showStateroomSuitePopup(this.shipSuiteImagePC);
        },
        onModalClose () {
            this.isShowModal = false
            this.showSmall = true
            this.adultCount = 0
            this.childCount = 0
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        },
         showCountLimit() {
            if(this.isShowToast) return
            this.isShowToast = true
            this.toastText = '预订人数过多，建议您咨询客服提供更优方案'
            setTimeout(() => {
              this.isShowToast = false
            }, 2000)
          },
        // 获取人数
    async getCountPeople(){
      // 获取人数上限 获取最大成人数和儿童数
      const res = await api.cruise.getMaxAdultAndChildCount();
      if (res.success) {
          console.log(res,'resresresres')
            this.adultCountAll = res.data.adultCount
            this.childCountAll = res.data.childCount
        }
    },
    // 加减人数 成人
    changeAdlCount(type){
      if(type == 'mine'){
        
        this.adultCount = this.adultCount - 1
        
      }else{
        // 加法
        if(this.adultCountAll > this.adultCount){
            this.adultCount = this.adultCount + 1
        }
        
      }
    },

    // 加减人数 未成年
    changeCheCount(type){
      if(type == 'mine'){
        
        this.childCount = this.childCount - 1
        
      }else{
        // 加法
        if(this.childCountAll > this.childCount){
            this.childCount = this.childCount + 1
        }
      }
    },

    // 提交人数
    async subCountPeple(){
      if(this.adultCount == 0){
          this.isShowToast = true
          this.toastText = '您房间中的乘客年龄可能不符合线上预订要求，具体请咨询客服'
        setTimeout(()=>{
            this.isShowToast = false
        },2000)
        return
      }

      // 提交人数
      const res = await api.cruise.getRecommendedRoomsByGuestCount({
          "SailCode": this.shipCodeHelper, 
          "AdultCount":this.adultCount, //成人数
          "ChildCount":this.childCount  //儿童数
        });
     
      if (res.success) {

        if (!res.data.stateroomRecommendationList || res.data.stateroomRecommendationList.length < 1) {

          this.isShowToast = true
          this.toastText = '预订人数过多，建议您咨询客服提供更优方案'
          setTimeout(() => {
            this.isShowToast = false
          }, 2000)
          return
        }

        console.log(res,'提交人数')
        // 切换视图
        
          this.showSmall = !this.showSmall
        
          this.cheepData = res.data.stateroomRecommendationList[0]
          this.goodData = res.data.stateroomRecommendationList[1]
          this.shipSuiteImagePC = res.data.shipSuiteImagePC
        
      }else{
    
        this.isShowToast = true
        this.toastText = res.errMsg

        setTimeout(()=>{
          this.isShowToast = false
        },2000)
      }
      
    },

    // 返回重新提交
    backFist(){
        this.showSmall = !this.showSmall
        this.getCountPeople()
    },

    },
    watch: {
        isShow (newValue) {
            if(newValue){
              this.getCountPeople()
            }
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        }
    }
}
</script>

<style lang="less" scoped>
.modal {
    overflow-y: auto;
}
.modal-body {
    padding: 0px;
    img {
        width: 100%;
    }
}
.modal-dialog {
    position: relative;
    top: 50%;
    left: 50%;
    width: 1000px;
    margin: 0;
    transform: translate(-50%,-50%) !important;
}

.modal.active {
    display: block;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}

@media screen and (max-width: 1400px) {
  .modal-content{
    transform: scale(0.75);
  }
}

.small-box{
  width: 1000px;
  height: 466px;
  background-image: url('https://resource.rcclchina.com.cn/wechatMiniProgram/routesDetail/housingSelection/pcHperSmall.png');
  background-size: 100% 100%;
  position: relative;
}
.small-box-title{
  text-align: center;
  line-height: 1;
  font-size: 28px;
  color: #282828;
  padding-top: 26px;
  padding-bottom: 26px;
  box-sizing: border-box;
}
.small-box-content{
  width: 900px;
  margin: 0 auto;
  padding: 26px 38px;
  box-sizing: border-box;
  border-radius: 10px;
  background: #fff;
  color: #282828;
  font-size: 20px;
}
.dis-flex{
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}
.small-box-content-line{ 
  width: 100%;
  height: 2px;
  background-color: #F3F4F7;
}
.small-box-content-img{
  width: 27px;
  height: 27px;
  margin-right: 12px;
}
.small-box-content-box{
  width: 100%;
  height: 156px;
  background: linear-gradient( 90deg, #FFF6DA 0%, #FFFFFF 100%);
  box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.05);
  border-radius: 10px;
  padding: 0 16px;
  box-sizing: border-box;
  position: relative;
}
.small-box-content-item{
  width: 100%;
  height: 77px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  color: #282828;
  font-size: 20px;
}
.small-box-content-item-right{
  display: flex;
  align-items: center;
}
.btn-box{
  width: 400px;
  height: 46px;
  background: linear-gradient( 90deg, #fcbf00 0%, #ffdb17 100%);
  border-radius: 5px;
  text-align: center;
  line-height: 46px;
  color: #282828;
  font-size: 20px;
  margin:30px auto 0;
  cursor: pointer;
}

.toest-box{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  // max-width: 754px;
  white-space: nowrap;

  background: rgba(0,0,0,0.7);
  border-radius: 10px;
  padding: 12px 40px;
  box-sizing: border-box;
  
  font-weight: 500;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
  font-style: normal;
}

.small-item-count-box{
  width: 140px;
  height: 34px;
  background: #FFF2B5;
  margin-right: 12px;
  border-radius: 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.width-height-44{
  width: 34px;height: 34px;
  cursor: pointer;
}

.small-box-close{
  width: 20px;
  height: 22px;
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
}

.big-box{
  width: 1000px;
  height: 700px;
  background-image: url('https://resource.rcclchina.com.cn/wechatMiniProgram/routesDetail/housingSelection/pcHelperBig.png');
  background-size: 100% 100%;
  position: relative;
}



.big-box-title{
  text-align: center;
  line-height: 1;
  font-size: 28px;
  color: #282828;
  padding-top: 26px;
  padding-bottom: 26px;
  box-sizing: border-box;
  font-weight: 500;
  strong{
    font-weight: bold;
    color: #ff791b;
  }
}

.big-item{
  width: 100%;
  padding: 66px 16px 16px;
  box-sizing: border-box;
  background: linear-gradient( 90deg, #FFF9DE 0%, #FFFFFF 100%);
  box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.05);
  border-radius: 10px;
  position: relative;
  margin-bottom: 22px;
}

.big-item-img{
  position: absolute;
  left: 0;
  top: 0;
  width: 166px;
  height: 48px;
  background: linear-gradient( 90deg, #FFBF58 0%, #FF781A 100%);
  border-radius: 0px 0px 10px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.big-item-img-i{
  width: 110px;height: 28px;
}

.big-item-text{
  
  font-weight: 400;
  font-size: 20px;
  color: #737373;
  line-height: 40px;
  text-align: left;
  font-style: normal;
}

.color-oringe{
  color:#FF791B;
}
.color-blue{
  color:#006AB6;
}
.color-blue-text{
  margin-top: 10px;
  color: #006AB6;
  cursor: pointer;
}
.color-under-text{
  text-decoration:underline;
}

.gray-text{
  color: #737373;
  font-size: 16px;
  margin-bottom: 10px;
}

.botton-box{
  margin: 0 auto;
  width: 407px;
  height: 42px;
  background: linear-gradient( 270deg, #FFDB17 0%, #FCBF00 100%);
  border-radius: 5px;
  cursor: pointer;
  
  font-weight: 500;
  font-size: 20px;
  color: #353535;
  line-height: 42px;
  text-align: center;
  font-style: normal;
  text-align: center;
}


</style>